import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Icon } from "../Icon/icon";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


/**
 *
 * @param {Object} props - Properties passed to component
 * @returns {ReactElement}
 */

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "onClick", "size"]);

  var closeIcon = size === "small" ? "xmark" : "xmark-thin";
  return React.createElement("button", _extends({
    className: classNames("oui-close-button", className),
    onClick: onClick
  }, props), React.createElement(Icon, {
    name: closeIcon,
    size: size
  }));
};

CloseButton.propTypes = {
  /** CSS class names. */
  className: PropTypes.string,

  /**
   *  Function to perform when the close button is clicked.
   */
  onClick: PropTypes.func.isRequired,

  /**
   *  Size of the close button.
   */
  size: PropTypes.oneOf(["small", "medium", "large"])
};
CloseButton.defaultProps = {
  size: "medium"
};
export default CloseButton;